import React, { useCallback, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useHideHeaderAndFooter, useWindowSize } from '@yme/common/hooks';
import { useTestRideDealers } from '@yme/components/TestRide/components/TestRideGrid/useTestRideDealers';
import { setTestRideCategoryId } from '@yme/components/TestRide/redux/actions';
import { TestRideGrid } from '@yme/organisms/test-ride-grid';
import { getCommercetoolsProjectKey, getIsoCountryCode, getLanguageRootPath, getRootLang, getRTL, getCurrentCountryConfig, getGlobalSearchItemId, getNavigationBreadCrumbs, } from '@yme/selectors/common';
import { DigitalDataMutation, selectColorTheme, setDigitalData } from '@yme/utils/common';
import { getAllProductsData, getDemoUnitsSeparately, getTestRideLinks } from './services';
import { BrandOverlineStyled, FlexWrapperStyled, PaddingBlockStyled } from './styled';
export function TestRideGridComponent(props) {
    const { hyperdriveEndpoints, isBrandOverline = false, isShowDriverLicenseFilter, pageBlockStrategy, googleApiKey, isInEditor, } = props;
    const dispatch = useDispatch();
    const [allProductsData, setAllProductsData] = useState([]);
    const [productData, rawSetProductData] = useState([]);
    const [testRideFormLinks, setTestFormRideLinks] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);
    const [isError, setIsError] = useState(false);
    const isoCountryCode = useSelector(getIsoCountryCode);
    const isRightToLeft = useSelector(getRTL);
    const language = useSelector(getRootLang);
    const languageRootPath = useSelector(getLanguageRootPath);
    const projectKey = useSelector(getCommercetoolsProjectKey);
    const navigationBreadCrumbs = useSelector(getNavigationBreadCrumbs);
    const { currentLanguageRoot, currentCountryRoot } = useSelector(getCurrentCountryConfig);
    const globalSearchItemId = useSelector(getGlobalSearchItemId);
    const { isMobileView } = useWindowSize();
    const { isInIframe, dealerIdList, isInIframeError } = useTestRideDealers();
    useHideHeaderAndFooter(isInIframe);
    const onSetTestRideCategoryId = useCallback((catId) => dispatch(setTestRideCategoryId(catId)), [dispatch]);
    const setProductData = useCallback((data) => {
        rawSetProductData(data.cards);
        setDigitalData(DigitalDataMutation.TEST_RIDE_VIEW_SEGMENT, {
            links: testRideFormLinks,
            products: data.products,
        });
    }, [testRideFormLinks]);
    useEffect(() => {
        const currentPath = window.location.pathname;
        getTestRideLinks(currentPath, setTestFormRideLinks);
    }, [currentCountryRoot, currentLanguageRoot, globalSearchItemId, navigationBreadCrumbs]);
    useEffect(() => {
        if (language && isoCountryCode && testRideFormLinks.length > 0 && !allProductsData.length) {
            getAllProductsData({
                language,
                hyperdriveEndpoints,
                navigationBreadCrumbs,
                currentLanguageRoot,
                currentCountryRoot,
                isLoadingCallback: setIsLoading,
                isLoadedCallback: setIsLoaded,
                isErrorCallback: setIsError,
                setAllProductsDataCallback: setAllProductsData,
                onSetTestRideCategoryId,
            });
        }
    }, [
        language,
        isoCountryCode,
        hyperdriveEndpoints,
        setProductData,
        testRideFormLinks.length,
        dealerIdList,
        projectKey,
        navigationBreadCrumbs,
        currentLanguageRoot,
        currentCountryRoot,
        onSetTestRideCategoryId,
        allProductsData,
    ]);
    useEffect(() => {
        if (isoCountryCode && allProductsData.length) {
            getDemoUnitsSeparately({
                isoCountryCode,
                isLoadingCallback: setIsLoading,
                isLoadedCallback: setIsLoaded,
                isErrorCallback: setIsError,
                setProductCallback: setProductData,
                dealerIdList,
                projectKey,
                allProductsData,
            });
        }
    }, [allProductsData, dealerIdList, isoCountryCode, projectKey, setProductData]);
    const testRide = (React.createElement(TestRideGrid, { googleApiKey: googleApiKey, isInEditor: isInEditor, dealerIdList: dealerIdList, productData: productData, testRideFormLinks: testRideFormLinks, isLoading: isLoading, isLoaded: isLoaded, isError: isError, isRightToLeft: isRightToLeft, isShowDriverLicenseFilter: isShowDriverLicenseFilter, languageRootPath: languageRootPath, isInIframeError: isInIframeError }));
    return (React.createElement(FlexWrapperStyled, { isFullWidth: true, justifyContent: "center" }, isBrandOverline ? (React.createElement(BrandOverlineStyled, { borderColor: selectColorTheme(pageBlockStrategy), borderSize: isMobileView ? '0' : '6px' },
        React.createElement(PaddingBlockStyled, null, testRide))) : (testRide)));
}
TestRideGrid.displayName = 'TestRideGrid_Component';
